import {
  SET_INVENTORY_FILTERS, RESET_INVENTORY_FILTERS, SET_INVENTORY_TYPE
} from '../actions/types';
import { InventoryTypes } from '../../constants';

const INITIAL_STATE = {
  inventoryType: InventoryTypes.SINGLE_FAMILY,
  filters: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_INVENTORY_FILTERS:
      return { ...state, filters: action.payload.filters };

    case RESET_INVENTORY_FILTERS:
      return { ...state, filters: {} };

    case SET_INVENTORY_TYPE:
      return { ...state, inventoryType: action.payload.inventoryType };

    default:
      return { ...state };
  }
}
